module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/transfer/transfer.component.html
// module id = 1292
// module chunks = 0